import { Directive } from '@angular/core';

@Directive({
  selector: '[app-table-body]',
  host: {
    class: '[&>*:nth-child(even)>td]:!bg-theme-50',
  },
})
export class TableBodyDirective {}
